import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  style: {"width":"100%","height":"350px"},
  class: "mt-4 mb-2"
}
const _hoisted_4 = {
  key: 1,
  style: {"float":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Radar = _resolveComponent("Radar")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.matchingScores != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.location)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.location.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Radar, {
            options: _ctx.chartOptions,
            data: _ctx.chartData
          }, null, 8, ["options", "data"])
        ]),
        (_ctx.matchingScores.length > 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchingScores.slice(3,6), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  _createVNode(_component_v_icon, {
                    medium: "",
                    style: _normalizeStyle({ 'color': _ctx.matchingColors[index+3] })
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-circle", -1)
                    ]))]),
                    _: 1
                  }, 8, ["style"]),
                  _createTextVNode(" " + _toDisplayString(item.name) + " (" + _toDisplayString(_ctx.$filters.percentage(item.score, _ctx.$i18n.locale, 0)) + ") ", 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchingScores.slice(0,3), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            _createVNode(_component_v_icon, {
              medium: "",
              style: _normalizeStyle({ 'color': _ctx.matchingColors[index] })
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-circle", -1)
              ]))]),
              _: 1
            }, 8, ["style"]),
            _createTextVNode(" " + _toDisplayString(item.name) + " (" + _toDisplayString(_ctx.$filters.percentage(item.score, _ctx.$i18n.locale, 0)) + ") ", 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}